import { HttpError } from "react-admin";

import { createApiClient } from "@/api";
import { HTTP_STATUS } from "@/constants/http";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/rad_user_make_prem_requests";

export const premiumIssuanceSchema: DataProviderSchema<
  "RadUserMakePremRequest",
  "jsonld"
> = {
  list: () =>
    Promise.resolve({
      data: [],
      total: 0,
    }),
  create: async ({ data: { deviceId } }) => {
    const { data } = await apiClient.POST(BASE_URL, {
      body: {
        deviceId: String(deviceId),
      },
    });

    if (!data)
      throw new HttpError(
        "Something went wrong!",
        HTTP_STATUS.INTERNAL_SERVER_ERROR,
      );

    return {
      data: { id: data["@id"] ?? deviceId, ...data },
    };
  },
};
